import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const markFulfillmentGroupDeleted = {
  name: "markFulfillmentGroupDeleted" as const,
  input: z.object({ fulfillmentGroupId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
